import {WriteOnEdgeStatusEnum} from "../../enums/dashboard/WriteOnEdgeStatusEnum";

export class WriteMetricValue {
  public metricId!: number;
  public ts!: number;
  public valueToWrite!: number | boolean | string;
  public commandStatus!: WriteOnEdgeStatusEnum;
  public koMessage?: string;

  constructor(metricId: number, timestamp: number, valueToWrite: number | boolean | string, status: WriteOnEdgeStatusEnum, koMessage?: string) {
    this.metricId = metricId;
    this.ts = timestamp;
    this.valueToWrite = valueToWrite;
    this.commandStatus = status;
    this.koMessage = koMessage;
  }
}
